{
  "version": 1,
  "asset_id": "49445efd-11d1-4f6b-9163-33b4878b86b8",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/49445efd-11d1-4f6b-9163-33b4878b86b8/band-tubing-1600.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/49445efd-11d1-4f6b-9163-33b4878b86b8/band-tubing-1600.jpg",
  "original_filename": "band-tubing-1600.jpg",
  "size": 134603,
  "content_type": "image/jpeg",
  "created_at": "2026-09-20T00:21:04Z"
}
